module.exports = __webpack_public_path__ + "static/TiemposTextWeb-RegularItalic-55b527672e869a8d11305ab29e59d4c0.woff";